import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ChevronDown, ChevronUp, Phone } from 'lucide-react';

const FAQSection = () => {
  const { t, language } = useLanguage();
  const [openIndex, setOpenIndex] = useState(0);

  const allQuestions = t('faq.questions') || [];
  const questions = allQuestions.slice(0, 5);

  return (
    <section id="faq" className="py-14 bg-[#f8fafc]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8">
          <span className="inline-block px-4 py-1.5 bg-[#0066b3]/8 text-[#0066b3] rounded-full text-xs font-semibold uppercase tracking-wider mb-3">
            {t('faq.subtitle')}
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#0f172a] tracking-tight">
            {t('faq.title')}
          </h2>
        </div>

        <div className="space-y-2">
          {questions.map((item, index) => (
            <div
              key={item.q}
              className="bg-white rounded-xl border border-gray-100 overflow-hidden"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full flex items-center justify-between text-left px-5 py-4 hover:bg-gray-50/50 transition-colors"
              >
                <span className="text-sm font-semibold text-[#1a2b3c] pr-4">{item.q}</span>
                <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center ${openIndex === index ? 'bg-[#0066b3] text-white' : 'bg-gray-100 text-gray-400'}`}>
                  {openIndex === index ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-[#5a6b7c] leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Compact CTA */}
        <div className="mt-6 flex items-center justify-center gap-4 text-sm text-[#5a6b7c]">
          <span>{language === 'ta' ? 'மேலும் கேள்விகள்?' : 'Have more questions?'}</span>
          <a href="tel:+914428461515" className="inline-flex items-center gap-1.5 text-[#0066b3] font-semibold hover:underline">
            <Phone size={14} /> {language === 'ta' ? 'அழைக்கவும்' : 'Call Us'}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
